export function throwIfAlreadyLoaded(parentModule: object, moduleName: string): void {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import ${moduleName} in the AppModule`);
  }
}
